import SavedFolders from '@/presentation/components/saved-folders/SavedFolders.vue';
export const name = 'FOLDERS.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row } = params;
    const { PATENT_ID, PN } = row || {};
    return [
        //@ts-ignore
        <SavedFolders patentId={PATENT_ID} patentNo={PN}></SavedFolders>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
